import { Component, OnInit } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { FooterNavigationBarComponent, MenuItem } from "../../../shared/components/footer-navigation-bar/footer-navigation-bar.component";
import { BqaRole, RoleSwitchService } from "../../shared/services/role-switch.service";

@Component({
  selector: "app-ccm-root",
  imports: [FooterNavigationBarComponent, RouterModule],
  templateUrl: "./ccm-root.component.html",
  styleUrl: "./ccm-root.component.scss"
})
export class CcmRootComponent implements OnInit {

  selectedTab = "schedule";
  tabs: MenuItem[] = [];

  private readonly baseTabs: MenuItem[] = [
    {
      tabName: "schedule",
      itemText: "Schedule",
      itemIconUriActive: "assets/icons/schedule-active.svg",
      itemIconUriInactive: "assets/icons/schedule-inactive.svg",
      route: "ccm/schedule"
    },
    {
      tabName: "complete",
      itemText: "Complete",
      itemIconUriActive: "assets/icons/complete-active.svg",
      itemIconUriInactive: "assets/icons/complete-inactive.svg",
      route: "ccm/complete"
    },
    {
      tabName: "search",
      itemText: "Search",
      itemIconUriActive: "assets/icons/search-active.svg",
      itemIconUriInactive: "assets/icons/search-inactive.svg",
      route: "ccm/search"
    }
  ];

  constructor(
    private router: Router,
    private roleSwitchService: RoleSwitchService
  ) { }

  ngOnInit(): void {
    this.preloadImages();
    this.tabs = this.buildTabs();

    const currentRouteWithoutLeadingSlash = this.router.url.slice(1);
    const matchingTab = this.tabs.find(tab => currentRouteWithoutLeadingSlash.startsWith(tab.route ?? ""));
    if (matchingTab) {
      this.selectedTab = matchingTab.tabName;
    }
  }

  // This is done so that all of the icons for the tabs are loaded
  // On component initialization. Eager loading does not work because
  // Some of these imgs are not in the dom because of angular's control flow.
  preloadImages() {
    const imagesToPreload = [
      "assets/icons/schedule-active.svg",
      "assets/icons/schedule-inactive.svg",
      "assets/icons/complete-active.svg",
      "assets/icons/complete-inactive.svg",
      "assets/icons/search-active.svg",
      "assets/icons/search-inactive.svg"
    ];

    imagesToPreload.forEach(src => {
      const img = new Image();
      img.src = src;
    });
  }

  onTabChanged(newTab: MenuItem) {
    this.selectedTab = newTab.tabName;
    this.router.navigate([newTab.route ?? ""]);
  }

  private buildTabs(): MenuItem[] {
    if (!this.roleSwitchService.hasBothAssignableRoles()) {
      return [...this.baseTabs];
    }

    return [
      ...this.baseTabs,
      this.roleSwitchService.getProfileTab(BqaRole.CustomerCareManager)
    ];
  }
}
